// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__EPs3I","icon":"Home_icon__3uy2d","card":"Home_card__3w9f_","title":"Home_title__1JJ7m"};